export default __webpack_public_path__ + "static/media/location.2984a884.png";